import React, { useState, useEffect } from 'react';
import { Button, FormGroup, Input, Col, Media, FormFeedback } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { isEqual } from 'lodash';
import PropTypes from "prop-types";
import usePrevProps from '../hooks/usePrevProps';

const TextCaptcha = (props) => {
    const { isLoadingCaptcha, onRefreshCaptcha, onCaptchaChange, captchaImage } = props;
    const [isCaptchaInValid, OnIsCaptchaInValid] = useState(false);
    const [captcha, onCaptchaEnter] = useState('');

    const prevCaptchaImage = usePrevProps(captchaImage);

    const handleCaptchaChange = (e) => {
        var captcha = e.target.value;
        OnIsCaptchaInValid(!captcha);
        onCaptchaEnter(captcha);
        if (onCaptchaChange) {
            onCaptchaChange(captcha);
        }
    }

    useEffect(() => {
        if ((captchaImage && !isEqual(prevCaptchaImage, captchaImage))) {
            onCaptchaEnter('');
            onCaptchaChange('');
        }
    }, [captchaImage]);

    if (!captchaImage) {
        return null;
    }
    return (
        <FormGroup row className="mb-3">
            <Col xs={12} sm={12} md={12} lg={12} xl={8}>
                <p className="mb-1"><small className="captcha-title">Please enter the text below</small></p>
                <Media className="mb-2 align-items-stretch">
                    <Media left>
                        <Media object src={'data:image/png;base64, ' + captchaImage} alt="Captcha" className={`w-100 border border-secondary ${isLoadingCaptcha ? 'blur-image' : ''} `} />
                    </Media>
                    <Media className="border border-secondary border-left-0">
                        <Button outline color="link" onClick={(e) => onRefreshCaptcha(e)} size="lg" className="shadow-none h-100">
                            <FontAwesomeIcon className={`text-info fa-w-14 ${isLoadingCaptcha ? 'rotating' : ''} `} icon={faSync} />
                        </Button>
                    </Media>
                </Media>
                <Input autoComplete="Off" type="text" name="captcha" id="captcha" className="custom__input" placeholder="Enter captcha text" value={captcha} bsSize="sm" onChange={handleCaptchaChange} onBlur={handleCaptchaChange} invalid={isCaptchaInValid} />
                <FormFeedback className="mx-2">Please enter captcha.</FormFeedback>
                <p className="mb-1"><small >(Text is case-sensitive)</small></p>

            </Col>
        </FormGroup>
    );
};

TextCaptcha.propTypes = {
    isLoadingCaptcha: PropTypes.bool,
    onRefreshCaptcha: PropTypes.func,
    onCaptchaChange: PropTypes.func,
    captchaImage: PropTypes.string
}

export default TextCaptcha;